import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import ProductionService from '../services/ProductionService';

const initialState = {
  data: [],
  datas: [],
  parent_datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  isSuccess: false,
  loading: false,
  submitLoading: false,
  isOpenProductionDialog: false,
  form: {
    initialValues: null,
    action: 'create',
    isOpen: false,
    isProduction: false,
  },
  ingredient: {
    isSuccess: false,
    submitLoading: false,
    formError: []
  },
  waste: {
    isSuccess: false,
    submitLoading: false,
    formError: []
  },
  cutUnit: {
    isSuccess: false,
    submitLoading: false,
    formError: []
  }
};

export const fetchProductionList = createAsyncThunk(
  'production/fetchProdcutionList',
  async ({ perPage, page, keyword, sku, type = '' }) => {
    try {
      const resp = await ProductionService.List({ perPage, page, keyword, type, sku });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const createProduction = createAsyncThunk(
  'production/createProduction',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.Create(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const deleteProduction = createAsyncThunk('production/deleteProduction', async (id, { rejectWithValue }) => {
  try {
    const resp = await ProductionService.Delt(id);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});


export const fetchProductionDetails = createAsyncThunk('production/detail', async (id) => {
  try {
    const resp = await ProductionService.Show(id);
    return resp;
  } catch (error) {
    return error.response;

  }
});

export const createIngredient = createAsyncThunk(
  'production/createIngredient',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.CreateIngredient(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const updateIngredient = createAsyncThunk(
  'production/updateIngredient',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.UpdateIngredient(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const deleteIngredient = createAsyncThunk('production/deleteIngredient', async (id, { rejectWithValue }) => {
  try {
    const resp = await ProductionService.DeleteIngredient(id);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});

export const createWaste = createAsyncThunk(
  'production/createWaste',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.CreateWaste(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const updateWaste = createAsyncThunk(
  'production/updateWaste',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.UpdateWaste(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const deleteWaste = createAsyncThunk('production/deleteWaste', async (id, { rejectWithValue }) => {
  try {
    const resp = await ProductionService.DeleteWaste(id);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});

export const createCutUnit = createAsyncThunk(
  'production/createCutUnit',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.CreateCutUnit(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const updateCutUnit = createAsyncThunk(
  'production/updateCutUnit',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.UpdateCutUnit(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const deleteCutUnit = createAsyncThunk('production/deleteCutUnit', async (id, { rejectWithValue }) => {
  try {
    const resp = await ProductionService.DeleteCutUnit(id);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});


export const updateProduction = createAsyncThunk(
  'production/updateProduction',
  async (data, { rejectWithValue }) => {
    try {
      const resp = await ProductionService.Put(data);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const prodcutionSlice = createSlice({
  name: 'prodcution',
  initialState: initialState,
  reducers: {
    openProductionDialog: (state, action) => {
      state.isOpenProductionDialog = action.payload;
    },
    setFormState: (state, action) => {
      state.form = {
        ...state.form,
        ...action.payload,
      };
    },
    resetState: (state) => {
      state.isSuccess = false;
      state.data = [];
      state.formError = {};
      state.ingredient = {
        isSuccess: false,
        submitLoading: false,
        formError: []
      };
      state.waste = {
        isSuccess: false,
        submitLoading: false,
        formError: []
      };
      state.cutUnit = {
        isSuccess: false,
        submitLoading: false,
        formError: []
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductionList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchProductionList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data?.productionList];
          state.pagination = action.payload?.data.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchProductionList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createProduction.pending, (state, action) => {
        state.submitLoading = true;
        state.formError = [];
        state.isSuccess = false;
      })
      .addCase(createProduction.fulfilled, (state, action) => {
        state.data = action.payload.data.data;
        toast.success(action.payload?.message);
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total + 1,
        };
        state.submitLoading = false;
        state.isSuccess = true;
        state.form = {
          initialValues: null,
          action: 'create',
          isOpen: false,
          isProduction: false,
        };
      })
      .addCase(createProduction.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.submitLoading = false;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(deleteProduction.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(deleteProduction.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.datas = state.datas.filter((item) => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isOpenProductionDialog = false;
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total > 0 ? state.pagination.total - 1 : 0,
        };
      })
      .addCase(deleteProduction.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error(action.payload?.data.message);
      })
      .addCase(updateProduction.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(updateProduction.fulfilled, (state, action) => {

        state.data = action.payload.data.data;
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
      })
      .addCase(updateProduction.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.submitLoading = false;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(fetchProductionDetails.pending, (state, action) => {
        state.formError = [];
        state.isSuccess = false;
      })
      .addCase(fetchProductionDetails.fulfilled, (state, action) => {
        state.data = action.payload.data.data;
        state.isSuccess = true;
      })
      .addCase(fetchProductionDetails.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(createIngredient.pending, (state, action) => {
        state.ingredient.formError = [];
        state.ingredient.isSuccess = false;
      })
      .addCase(createIngredient.fulfilled, (state, action) => {
        state.data.ingredients.push(action.payload.data.data);
        state.ingredient.isSuccess = true;
        toast.success("Ingredient added successfully.")
      })
      .addCase(createIngredient.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.ingredient.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.ingredient.formError = errors;
        }
      })
      .addCase(updateIngredient.pending, (state, action) => {
        state.ingredient.formError = [];
        state.ingredient.isSuccess = false;
      })
      .addCase(updateIngredient.fulfilled, (state, action) => {
        const updatedIngredient = action.payload.data.data;
        // Find the index of the ingredient with matching ID
        const index = state.data.ingredients.findIndex(
          ing => ing.id === updatedIngredient.id
        );

        if (index !== -1) {
          // Replace the existing ingredient with the updated one
          state.data.ingredients[index] = updatedIngredient;
        } else {
          // If not found (shouldn't happen), add it as fallback
          state.data.ingredients.push(updatedIngredient);
        }

        state.ingredient.isSuccess = true;
        toast.success("Ingredient updated successfully.");
      })
      .addCase(updateIngredient.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.ingredient.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.ingredient.formError = errors;
        }
      })
      .addCase(deleteIngredient.pending, (state, action) => {
        state.ingredient.submitLoading = true;
      })
      .addCase(deleteIngredient.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.data.ingredients = state.data.ingredients.filter((item) => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.ingredient.submitLoading = false;
      })
      .addCase(deleteIngredient.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.ingredient.submitLoading = false;
        toast.error(action.payload?.data.message);
      })
      .addCase(createWaste.pending, (state, action) => {
        state.waste.formError = [];
        state.waste.isSuccess = false;
      })
      .addCase(createWaste.fulfilled, (state, action) => {
        state.data.wastes.push(action.payload.data.data);
        state.waste.isSuccess = true;
        toast.success("Waste added successfully.")
      })
      .addCase(createWaste.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.waste.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.waste.formError = errors;
        }
      })
      .addCase(updateWaste.pending, (state, action) => {
        state.waste.formError = [];
        state.waste.isSuccess = false;
      })
      .addCase(updateWaste.fulfilled, (state, action) => {
        const updatedWaste = action.payload.data.data;
        // Find the index of the ingredient with matching ID
        const index = state.data.wastes.findIndex(
          ing => ing.id === updatedWaste.id
        );

        if (index !== -1) {
          // Replace the existing ingredient with the updated one
          state.data.wastes[index] = updatedWaste;
        } else {
          // If not found (shouldn't happen), add it as fallback
          state.data.wastes.push(updatedWaste);
        }

        state.waste.isSuccess = true;
        toast.success("Waste updated successfully.");
      })
      .addCase(updateWaste.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.waste.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.waste.formError = errors;
        }
      })
      .addCase(deleteWaste.pending, (state, action) => {
        state.waste.submitLoading = true;
      })
      .addCase(deleteWaste.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.data.wastes = state.data.wastes.filter((item) => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.waste.submitLoading = false;
      })
      .addCase(deleteWaste.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.waste.submitLoading = false;
        toast.error(action.payload?.data.message);
      })
      .addCase(createCutUnit.pending, (state, action) => {
        state.cutUnit.formError = [];
        state.cutUnit.isSuccess = false;
      })
      .addCase(createCutUnit.fulfilled, (state, action) => {
        state.data.cutUnits.push(action.payload.data.data);
        state.cutUnit.isSuccess = true;
        state.data = {
          ...state.data,
          quantity_produced: (state.data.quantity_produced || 0) + 1
        };
        toast.success("Cut Unit added successfully.");
      })
      .addCase(createCutUnit.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.cutUnit.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.cutUnit.formError = errors;
        }
      })
      .addCase(updateCutUnit.pending, (state, action) => {
        state.cutUnit.formError = [];
        state.cutUnit.isSuccess = false;
      })
      .addCase(updateCutUnit.fulfilled, (state, action) => {
        const updatedCutUnit = action.payload.data.data;
        // Find the index of the ingredient with matching ID
        const index = state.data.cutUnits.findIndex(
          ing => ing.id === updatedCutUnit.id
        );

        if (index !== -1) {
          // Replace the existing ingredient with the updated one
          state.data.cutUnits[index] = updatedCutUnit;
        } else {
          // If not found (shouldn't happen), add it as fallback
          state.data.cutUnits.push(updatedCutUnit);
        }

        state.cutUnit.isSuccess = true;
        toast.success("Cut Unit updated successfully.");
      })
      .addCase(updateCutUnit.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.cutUnit.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.cutUnit.formError = errors;
        }
      })
      .addCase(deleteCutUnit.pending, (state, action) => {
        state.cutUnit.submitLoading = true;
      })
      .addCase(deleteCutUnit.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.data.cutUnits = state.data.cutUnits.filter((item) => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.cutUnit.submitLoading = false;
        state.data = {
          ...state.data,
          quantity_produced: state?.data?.quantity_produced - 1
        }
      })
      .addCase(deleteCutUnit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.cutUnit.submitLoading = false;
        toast.error(action.payload?.data.message);
      })
  },
});

const { reducer } = prodcutionSlice;

export const { openProductionDialog, setFormState, resetState } = prodcutionSlice.actions;

export const prodcutionSelector = (state) => state?.production;

export default reducer;
